export default (email, userId) => ire('identify', {
    customerId: userId,
    customerEmail: email
});
